import { addDays, endOfDay, startOfDay, startOfMonth, endOfMonth, addMonths, startOfWeek, endOfWeek, isSameDay, differenceInCalendarDays, } from 'date-fns';
var defineds = {
    startOfWeek: startOfWeek(new Date()),
    endOfWeek: endOfWeek(new Date()),
    startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
    endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
};
export var defaultInputRanges = function () {
    return [
        {
            label: 'days up to yesterday',
            range: function (value) {
                return {
                    startDate: addDays(defineds.startOfYesterday, (Math.max(Number(value), 1) - 1) * -1),
                    endDate: defineds.endOfYesterday,
                };
            },
            getCurrentValue: function (range) {
                if (!isSameDay(range.endDate, defineds.endOfYesterday))
                    return '-';
                if (!range.startDate)
                    return '∞';
                return differenceInCalendarDays(defineds.endOfYesterday, range.startDate) + 1;
            },
        }
        // {
        //   label: 'days starting yesterday',
        //   range(value: any) {
        //     const today = new Date();
        //     return {
        //       startDate: today,
        //       endDate: addDays(today, Math.max(Number(value), 1) - 1),
        //     };
        //   },
        //   getCurrentValue(range: any) {
        //     if (!isSameDay(range.startDate, defineds.startOfToday)) return '-';
        //     if (!range.endDate) return '∞';
        //     return differenceInCalendarDays(range.endDate, defineds.startOfToday) + 1;
        //   },
        // },
    ];
};
export var reportInputRanges = function () {
    var minDate = new Date(new Date().getFullYear() - 2, 0, 1);
    var maxDate = new Date(new Date().getFullYear(), 0, 1);
    var numberOfDate = differenceInCalendarDays(maxDate, minDate) + 1;
    return [
        {
            label: 'days up to yesterday',
            range: function (value) {
                return {
                    startDate: addDays(defineds.startOfYesterday, (Math.max(Number(value), 1) - 1) * -1),
                    endDate: defineds.endOfYesterday,
                };
            },
            getCurrentValue: function (range) {
                if (!isSameDay(range.endDate, defineds.endOfYesterday))
                    return '-';
                if (!range.startDate)
                    return '∞';
                var dateInput = differenceInCalendarDays(defineds.endOfYesterday, range.startDate) + 1;
                if (dateInput > numberOfDate) {
                    range.startDate = addDays(defineds.startOfYesterday, (Math.max(Number(30), 1) - 1) * -1);
                    range.endDate = defineds.endOfYesterday;
                    return 30;
                }
                else {
                    return dateInput;
                }
            },
        }
    ];
};
